import { IntegerStepperWidget } from '@tableau/widgets';
import React from 'react';

import { ReactActionDialogBodyProps } from '~commonInfra/dialogs/ReactActionDialog';

import { Messages } from '../../codegen/Localize';
import { RunFlowTasks } from '../resources/RunFlowTasks';

export type FlowTasksPriorityDialogContentProps = {
  readonly dialogMessage: string;
  readonly start: number;
}

export type FlowTasksPriorityDialogState = {
  readonly value: number;
}

export const priorityDialogMessageTestId: string = 'priority-dialog-message';

export function FlowTasksPriorityDialogContent(props: ReactActionDialogBodyProps<FlowTasksPriorityDialogContentProps, FlowTasksPriorityDialogState>) {

  const onChange = React.useCallback(
    (priority: number) => {
      props.updateDialogState({ value: priority });
    },
    // This noncompliance existed before the lint rule was enabled. If you're here, please consider fixing it! See TFS 1257824
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [props.updateDialogState]
  );

  const stepperProps = {
    min: RunFlowTasks.MIN_PRIORITY,
    max: RunFlowTasks.MAX_PRIORITY,
    start: props.start,
    testId: 'changeRunFlowTasksPriorityActionStepper',
    onValueUpdated: onChange,
  };
  return (
    <div>
      <div data-tb-test-id={priorityDialogMessageTestId}>{props.dialogMessage}</div>
      <IntegerStepperWidget {...stepperProps}/>
      <div>{Messages.createScheduleFormPriorityDescription()}</div>
    </div>
  );
}
